import React, { Component } from 'react';
import * as Config from './../config/Config';
import * as Common from './../helpers/Common';
import * as User from './../helpers/User';
const $=window.$;

//const $=window.$;
// const win=window;

class Challenge extends Component {
	constructor(props) {
		super(props);

        this.state={   
        	historys:[],
        	odd_arr:[],
        	acc:[],
        	rank:[]
        };
		this.getLrinfo=this.getLrinfo.bind(this);

	}	

  hideShow(e){
    $('.silverheader').removeClass('selected');
    $('.'+e).addClass('selected');
    $('.submenu').css('display','none');
    $('#'+e).css('display','block');
    //normal-accordion

  }

	getChallenge(){
			let learnerID   = Common.getUserData("id", true);
			let pinNo 		= Common.getUserData("pinNo", true);
			let pinID 		= Common.getUserData("pinID", true);
			let corporateID = Common.getUserData("corporateID", true);
			let productID 	= Common.getUserData("productID", true);
			let specialExpiryDate = Common.getUserData("specialExpiryDate", true);

			Common.reactLoader("show", "Please wait...");
    	fetch(Config.domainUrl+'challenge-score/challenge', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },
                  body: JSON.stringify({
                    learnerID:learnerID,
          					pinNo:pinNo,
          					pinID:pinID,
          					corporateID:corporateID,
          					productID:productID
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
                if(responseJson.status != 0){
  								 let historys = (responseJson.challenge_result.historys!=undefined) ? responseJson.challenge_result.historys : '';
  								 let acc      = (responseJson.challenge_result.acc!=undefined) ? responseJson.challenge_result.acc : '';
  								 let odd_arr  = (responseJson.challenge_result.odd_arr!=undefined) ? responseJson.challenge_result.odd_arr : '';
  								 let rank  = (responseJson.challenge_result.rank!=undefined) ? responseJson.challenge_result.rank : '';
  								 
  								 this.setState({
  								 	challenge_result:responseJson.challenge_result,
  								 	historys:historys,
  								 	odd_arr:odd_arr,
  								 	acc:acc,
  								 	rank:rank
  								 });
  								Common.reactLoader("hide");
  								Common.downTabClose();
								}
   		 			});
    }

	componentDidMount() {
		this.getChallenge();
	
	}

	getLrinfo(type,lr_id,dlr_id){
		this.props.switchPanel(type,lr_id,dlr_id);
	}

		render() {
			let historys = null;
      if(this.state.historys!=null || this.state.historys!=undefined) {
  			historys = this.state.historys.map((key,index)=>{
  				return(<tr key={`lr-key${index}`}>
                    <td align="center">{key['sno']}</td>
                    <td align="center">LR {key['learning_room_cnt']} Challenge {key['sno']}</td>
                    <td align="center">{this.state.odd_arr[key['odd_id_fk']]}</td>
                    <td align="center">{key['invested_amount']}</td>
                    <td align="center">{key['status']}</td>
                    <td align="center">{key['money_in_hand']}</td>
                </tr>)
  			});
      }

			let acc = null;
      if(this.state.acc!=null || this.state.acc!=undefined) {
  			acc = this.state.acc.map((key,index)=>{
  				return(<tr key={`acc-key${index}`}>
                    <td align="center">{key['sno']}</td>
                    <td align="center">{key['challenged_date']}</td>
                    <td align="center">LR {key['learning_room_cnt']} Challenge {this.state.odd_arr[key['odd_id_fk']]}</td>
                    <td align="center">{key['losing_amount']}</td>
                    <td align="center">{key['winning_amount']}</td>
                    <td align="center">{key['money_in_hand']}</td>
                </tr>)
  			});
      }

			let rank = null;
      if(this.state.rank!=null || this.state.rank!=undefined) {
  			rank = this.state.rank.map((key,index)=>{
  				return(<tr key={`rank-key${index}`}>
                      <td align="center">{key['firstname']}</td>
                      <td align="center">{key['money_in_hand']}</td>
                      <td align="center">{index+1}</td>
                      <td align="center">{key['no_of_bets']}</td>
                  </tr>)
  			});
      }

			
			
		return (
		 <section id="" className="contentarea main-inner practicescore scoreround">
		 <div className="border-box">
          <div className="title-bg">
            <h1> <span> <img src={process.env.PUBLIC_URL+'/images/img-lr1.png'} align="absmiddle" alt="" border="0" /> </span>
              <span className="subtitle">Challenge Score Card - Total Challenge report.</span></h1> 
              <span><input type="button" value="Go back" title="Go back" style={{float:'right'}}  className="button_org" onClick={() => window.location.reload(true)} /></span>
          </div>

          <section id="semana-scroll-inner" className="scrollbar">
      
            <section className="viewport">
              <section className="overview">
                <div className="inner-content">
                  <section className="">    
                      <div className="applemenu">               	
                          <div className="silverheader history">
                              <a href="javascript:void(0);" style={{backgroundColor:'#327277'}} onClick={(e) =>this.hideShow('history')} className="guide"><span>Challenge History </span></a>
                          </div>
                          <div className="submenu" id="history" style={{display:'none'}}>
                              <section className="viewport">
                                  <section id="module-wise">
                                      <div className="chartstatus" style={{textAlign: 'left'}}>
                                         <table width="100%" cellSpacing="0" cellPadding="0" border="1" style={{borderCollapse:'collapse', border: 'solid 1px #e5e5e5'}}>
                                          <tbody>
                                            <tr style={{backgroundColor:'#000066', color:'#ffffff'}}>
                                              <th align="center">S.No</th>
                                              <th align="center">Challenges</th>
                                              <th align="center">Original Challenge</th>
                                              <th align="center">Bet Amount</th>
                                              <th align="center">Challenge Status</th> 
                                              <th align="center">Amount Loss/Won</th>                    
                                            </tr>
                                                 {historys!='' ? 
                                                 historys
                                                 :
                                                 <tr><td colSpan='6'>No Records Found</td></tr> 
                                               }
                                          </tbody>
                                        </table>
                                      </div>                              	
                                  </section>
                              </section>
                          </div> 

                          <div className="silverheader account">
                              <a href="javascript:void(0);" onClick={(e) =>this.hideShow('account')} style={{backgroundColor:'#327277'}} className="guide"><span>Statement of Account </span></a>
                          </div>
                          <div className="submenu" id="account" style={{display:'none'}}>
                              <section className="viewport">
                                  <section id="module-wise">
                                      <div className="chartstatus" style={{textAlign: 'left'}}>
                                         <table width="100%" cellSpacing="0" cellPadding="0" border="1" style={{borderCollapse:'collapse', border: 'solid 1px #e5e5e5'}}>
                                          <tbody>
                                            <tr style={{backgroundColor:'#000066', color:'#ffffff'}}>
                                              <th align="center">S.No</th>
                                              <th align="center">Date</th>
                                              <th align="center">Narration</th>
                                              <th align="center">Debit</th>
                                              <th align="center">credit</th> 
                                              <th align="center">Balance</th>                    
                                            </tr>
                                                {acc!='' ? 
                                                 acc
                                                 :
                                                 <tr><td colSpan='6'>No Records Found</td></tr> 
                                               }                                    
                                          </tbody>
                                        </table>
                                      </div>                                  
                                  </section>
                              </section>
                          </div>

                          <div className="silverheader ranking">
                              <a href="javascript:void(0);" onClick={(e) =>this.hideShow('ranking')} style={{backgroundColor:'#327277'}} className="guide"><span>Ranking </span></a>
                          </div>
                          <div className="submenu" id="ranking" style={{display:'none'}}>
                              <section className="viewport">
                                  <section id="module-wise">
                                      <div className="chartstatus" style={{textAlign: 'left'}}>
                                         <table width="100%" cellSpacing="0" cellPadding="0" border="1" style={{borderCollapse:'collapse', border: 'solid 1px #e5e5e5'}}>
                                          <tbody>
                                            <tr style={{backgroundColor:'#000066', color:'#ffffff'}}>
                                              <th align="center">Learner Name</th>
                                              <th align="center">Money at Hand</th>
                                              <th align="center">Rank</th>
                                              <th align="center">Number of Bets</th>
                                            </tr>
                                                {rank!='' ? 
                                                 rank
                                                 :
                                                 <tr><td colSpan='4'>No Records Found</td></tr> 
                                               }  
                                          </tbody>
                                        </table>
                                      </div>                                  
                                  </section>
                              </section>
                          </div>

                      </div>
                  </section>
                </div>
              </section>
            </section>

          </section>
      </div>
      </section>


			);

		}
}

export default Challenge;



// WEBPACK FOOTER //
// ./src/challenge_score_card/Challenge.js